import type { SVGProps } from 'react';
export const AccountStatusAccepted = (props: SVGProps<SVGSVGElement>) => (
  <svg width="1rem" height="1rem" fill="currentColor" viewBox="0 0 10 10" {...props}>
    <path
      fill="#4EA14E"
      d="M7.2 3.57a.4.4 0 0 1 0 .55l-2.7 2.7a.4.4 0 0 1-.54 0L2.8 5.65a.38.38 0 0 1 .55-.55l.88.88 2.42-2.42a.4.4 0 0 1 .55 0M10 5A5 5 0 1 1 0 5a5 5 0 0 1 10 0m-.77 0A4.23 4.23 0 1 0 .77 5a4.23 4.23 0 0 0 8.46 0"
    />
  </svg>
);
